import type { RoleName } from '../constants/roles';
import { ROLES } from '../constants/roles';
import { REPORTS } from '../constants/reports';

export interface NavItem {
  key: string; // route path
  label: string;
  roles: readonly RoleName[];
  children?: NavItem[];
}

// Main-app navigation (AppLayout). Visibility is role-filtered client-side (UX only).
// Allowed roles mirror the route table in architecture §4.2.
export const APP_NAV: NavItem[] = [
  {
    key: '/dashboard',
    label: 'داشبورد',
    roles: [ROLES.CallCenterManager, ROLES.Supervisor, ROLES.ManagementObserver],
  },
  {
    key: '/calls',
    label: 'تماس‌ها',
    roles: [
      ROLES.SystemAdministrator,
      ROLES.CallCenterManager,
      ROLES.Supervisor,
      ROLES.QualityControlSpecialist,
    ],
  },
  {
    key: '/review-queue',
    label: 'صف بازبینی',
    roles: [ROLES.QualityControlSpecialist, ROLES.Supervisor],
  },
  {
    key: '/reports',
    label: 'گزارش‌ها',
    roles: [
      ROLES.CallCenterManager,
      ROLES.Supervisor,
      ROLES.QualityControlSpecialist,
      ROLES.TrainingUser,
      ROLES.ManagementObserver,
    ],
    children: REPORTS.map((report) => ({ key: `/reports/${report.type}`, label: report.title, roles: report.roles })),
  },
];

// Admin navigation (AdminLayout) — System Administrator only.
export const ADMIN_NAV: NavItem[] = [
  { key: '/admin/users', label: 'کاربران', roles: [ROLES.SystemAdministrator] },
  { key: '/admin/organization', label: 'سازمان', roles: [ROLES.SystemAdministrator] },
  { key: '/admin/audit', label: 'گزارش حسابرسی', roles: [ROLES.SystemAdministrator] },
  { key: '/admin/ingestion-errors', label: 'خطاهای دریافت', roles: [ROLES.SystemAdministrator] },
];

/** Keep only the items (and children) visible to `role`. */
export function filterNav(items: NavItem[], role: string): NavItem[] {
  return items
    .filter((item) => item.roles.includes(role as RoleName))
    .map((item) => (item.children ? { ...item, children: filterNav(item.children, role) } : item));
}
